import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/kihi logo.png'
import ServiceSection4 from '../../components/ServiceSection4/ServiceSection4';


const ServicePage4 = () => {
    return (
        <Fragment>
            {/* <HeaderTopbar /> */}
            <Navbar hclass={'wpo-site-header wpo-site-header-s3'} Logo={Logo} />
            <PageTitle pageTitle={'Products'} pagesub={'Products'} />
            <ServiceSection4 hclass={'wpo-service-section-s2 s2 section-padding'} />
            <Footer />
            <Scrollbar />

        </Fragment>
    )
};
export default ServicePage4;
